<template>
    <div class="list__item item_view_unit"
         :class="{
            'item_active': isActive,
            'item_view_unit__group': subShipments.length,
            'item_view_unit-empty': !unitId,
         }"
         :data-group-id="groupId" :data-shipment-id="shipmentId"
         @click.stop="setUnitActive"
         @mouseover="showMenu = true" @mouseleave="showMenu = false"
    >
        <ShipmentList_item_icons :shipmentId="shipmentId" :indicators="indicators"/>

        <div class="list__title-line">
            <h4 class="list__title">
                <spna class="list__title-icon" :class="shipmentStatus.class">
                    <SvgIcon :name="shipmentStatus.icon" class="icon"/>
                </spna>
                <span class="list__title-info" :title="shipmentName">
                    {{shipmentName}}
                </span>
            </h4>
            <UnitsList_unit_timeago :unit-id="unitId" v-if="shipment?.status !== 'completed'"/><!-- ! -->
            <ShipmentList_completed_date :shipmentId="shipmentId" v-if="shipment?.status === 'completed'"/>
        </div>
        <div class="list__address-line">
            <UnitsList_unit_address :unit-id="unitId" v-if="unitId"/><!-- ! -->
            <ShipmentList_address :shipmentId="shipmentId" v-else/>

            <UnitsList_unit__status :unit-id="unitId" v-if="false"/><!-- ! -->
        </div>
        <div class="item_view_unit__dropdown" v-if="subShipments.length">
            <button class="button button_command" @click="showSubUnits = !showSubUnits">
                <SvgIcon :name="showSubUnitsButtonIcon" class="icon"/>
            </button>
        </div>
        <ShipmentList_menu
            :shipmentId="shipmentId"
            :commands="['copy_shipment_id', 'edit']"
            v-if="(showMenu || modalsWindows?.popupOutput )"
        />
    </div>
    <div class="item_view_unit__group--active" v-show="showSubUnits" v-if="subShipments?.length && false">
        <template v-for="shipment in subShipments" :key="shipment.shipmentId">
            <component :is="'ShipmentList_item'"  v-bind="shipment"/>
        </template>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {computed} from "vue";
    import unitMixin from "@/mixins/unitMixin";

    import UnitsList_unit_timeago from "@/components/units/UnitsList_unit_timeago.vue";
    import UnitsList_unit_address from "@/components/units/UnitsList_unit_address.vue";
    import UnitsList_unit__status from "@/components/units/UnitsList_unit__status.vue";
    import ShipmentList_completed_date from "@/components/shipment/ShipmentList_completed_date";
    import ShipmentList_address from "@/components/shipment/ShipmentList_address.vue";
    //import ShipmentList_menu from "@/components/units/ShipmentList_menu.vue";
    import ShipmentList_menu from "@/components/shipment/ShipmentList_menu.vue";
    import ShipmentList_item_icons from "@/components/shipment/ShipmentList_item_icons.vue";
    import ShipmentList_item from "@/components/shipment/ShipmentList_item_default.vue"

    const shipmentStatus = {
        'started':{
            class: 'list__status--started',
            icon: 'from'
        },
        'accepted':{
            class: 'list__status--completed--planed',
            icon: 'common__checkbox'
        },
        'completed':{
            class: 'list__status--completed',
            icon: 'common__checkbox'
        },
        'cancelled':{
            class: 'list__status--completed',
            icon: 'common__checkbox'
        },
        'planed':{
            class: 'list__status--planed',
            icon: 'clock'
        },
        'active':{
            class: 'list__status--planed',
            icon: 'clock'
        },
    }

    export default {
        name: 'ShipmentList_item_default',
        mixins: [unitMixin],
        inheritAttrs: false,
        components: {
            ShipmentList_item_icons,
            ShipmentList_item,
            UnitsList_unit_address,
            UnitsList_unit_timeago,
            UnitsList_unit__status,
            ShipmentList_completed_date,
            ShipmentList_address,
            ShipmentList_menu,
        },
        props: {
            itemId: Number,
            groupId: Number,
        },
        data() {
            return {
                modalsWindows: {},
                showMenu: false,
                showSubUnits: false,
            }
        },
        provide() {
            return {
                modalsWindows: computed(() => this.modalsWindows)
            }
        },
        computed: {
            ...mapGetters([
                "getTimeToday",
                "getShipments",
                "getShipmentsById",
                "getUserStorageKey",
            ]),
            shipmentId() {
                return this.itemId
            },
            shipment() {
                return this.getShipmentsById[this.shipmentId]
            },
            shipmentName(){
                return this.shipment?.name || ''
            },
            unitId() {
                return this.shipment?.unit_id
            },
            indicators() {
                return []
            },
            isActive(){
                return this.routeFilter.shipmentId == this.shipmentId
            },
            showSubUnitsButtonIcon() {
                return `vector-` + (this.showSubUnits ? 'top' : 'down')
            },
            shipmentStatus() {
                return shipmentStatus[this.shipment?.status || 'planed']
            },
            subShipments() {
                return []
            }
        },
        watch: {
            isActive(newVl) {
                if (!newVl) {
                    this.showSubUnits = false
                }
            },
        },
        methods: {
            setUnitActive(){
                this.setRoute.shipmentId(this.$route, this.$router, this.shipmentId)
            },
        },
        updated() {
            // console.log(`unit ${this.unitId} updated`);
        },
        mounted() {
        },
        beforeUnmount() {
        },
    }
</script>
<style lang="scss" scoped>
@import "~@/scss/02-components/shipment-list-item";
</style>
